<script lang="ts">
  import type { Facility } from '@bond/bruce-api/common/facility'
  import Icon from './base/Icon.svelte'
  import { utils } from '$lib/utils'

  export let facility: Facility
</script>

<div class="badge">
  <Icon icon={utils.facilityCodeToIcon(facility.code)} />
  {facility.title}
</div>

<style lang="scss">
  .badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    font-weight: 500;
    padding: 0.25em 0.5em;
    max-width: max-content;
  }
</style>
